import React from "react"

function Twitter(props) {
  return (
    <div {...props}>
      <svg
        className="w-full h-full"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="15" fill="#F4F4F4" />
        <path
          d="M21.4949 11.9384C21.4949 16.6099 17.9446 22 11.4333 22C9.43532 22 7.56674 21.4251 6 20.4189C6.28747 20.4476 6.56057 20.462 6.84805 20.462C8.50103 20.462 10.0246 19.9014 11.232 18.9528C9.67967 18.924 8.37166 17.9035 7.92608 16.4949C8.14168 16.5236 8.35729 16.5524 8.58727 16.5524C8.90349 16.5524 9.21971 16.5092 9.52156 16.4374C7.89733 16.1068 6.68994 14.6838 6.68994 12.9733V12.9302C7.16427 13.1889 7.71047 13.3614 8.28542 13.3758C7.33676 12.7433 6.70431 11.6509 6.70431 10.4292C6.70431 9.76797 6.8768 9.16427 7.17864 8.64682C8.91786 10.7885 11.5339 12.1971 14.4661 12.3409C14.4086 12.0821 14.3799 11.809 14.3799 11.5359C14.3799 9.58111 15.961 8 17.9158 8C18.9363 8 19.8563 8.43121 20.5031 9.12115C21.308 8.96304 22.0698 8.67556 22.7454 8.2731C22.4867 9.0924 21.9261 9.78234 21.193 10.2279C21.9117 10.1561 22.5873 9.95483 23.2341 9.68172C22.7598 10.386 22.1561 11.0041 21.4661 11.5072C21.4661 11.6653 21.4661 11.809 21.4661 11.9671L21.4949 11.9384Z"
          fill="#A0A0A0"
        />
      </svg>
    </div>
  )
}

export default Twitter
